import React from 'react';
import { Typography } from '@mui/material';
import VariableTextField from '../../VariableTextField';
import { waInlineMarkdown } from '../whatsappPreview';
import { FlowComponent } from '../../../../flow-core/FlowComponent';
import { TextBodyCore } from '../../../../flow-core/components/TextBodyCore';

export const TextBodyComponent = new FlowComponent({
  ...TextBodyCore,
  renderPreview(properties) {
    const text = properties.text || 'Body text content';
    return (
      <Typography sx={{ fontSize: 16, color: 'text.primary', mb: 1.5, whiteSpace: 'pre-line' }}>
        {properties.markdown ? waInlineMarkdown(text) : text}
      </Typography>
    );
  },
  renderPropertyEditor(properties, onChange, context) {
    return (
      <VariableTextField
        fullWidth
        label="Text"
        value={properties.text || ''}
        onChange={(e) => onChange('text', e.target.value)}
        required
        multiline
        rows={3}
        inputProps={{ maxLength: 4096 }}
        helperText={`${(properties.text || '').length}/4096 characters, use {x} to insert field references`}
        size="small"
        screens={context?.screens}
        currentScreenId={context?.currentScreenId}
      />
    );
  },
});
